import axios from 'axios';
import { getToken, isTokenExpired } from '@/services/utils/securityUtils';
import { useUserStore } from '@/store_pinia/userStore';

export default class BaseApiService {
  constructor(config) {
    this.axioInstance = axios.create(config);
  }

  get(url, queryParams, headers, responseType) {
    return this.axioInstance.get(url, this._createRequestConfig(queryParams, headers, responseType));
  }

  async post(url, data, queryParams, headers, responseType) {
    // eslint-disable-next-line no-useless-catch
    try {
      const res = await this.axioInstance.post(
        url,
        data,
        this._createRequestConfig(queryParams, headers, responseType)
      );
      return res;
    } catch (error) {
      throw error;
    }
  }

  put(url, data, queryParams, headers, responseType) {
    return this.axioInstance.put(url, data, this._createRequestConfig(queryParams, headers, responseType));
  }

  patch(url, data, queryParams, headers, responseType) {
    return this.axioInstance.patch(url, data, this._createRequestConfig(queryParams, headers, responseType));
  }

  delete(url, queryParams = {}, headers = {}, responseType) {
    return this.axioInstance.delete(url, this._createRequestConfig(queryParams, headers, responseType));
  }

  _createRequestConfig(
    queryParams = {},
    headers = {
      Accept: 'application/json, text/plain',
      'Content-Type': 'application/json;charset=UTF-8',
    },
    responseType = 'json'
  ) {
    // AxiosRequestConfig
    let paramsHeader = {
      params: queryParams,
      headers: headers,
      responseType: responseType,
    };
    const jwt = getToken();
    if (jwt) {
      if (isTokenExpired()) {
        useUserStore().logout();
      } else {
        paramsHeader.headers['Authorization'] = 'Bearer ' + jwt;
      }
    }
    return paramsHeader;
  }
}
